export default function unreachable(val: never): never {
  throw new Error(`Reached unreachable with value \`${JSON.stringify(val)}\``);
}
